export default {
  wallActive: 0,
  sliderDownload: false,
  interiors: null,
  interiorActive: '',
  windowActive: '',
  windows: null,
}
